import { useState, useEffect, useRef } from 'react';
import config from "../../../config/app-config";

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useHistory, withRouter } from 'react-router-dom';

import { Box, Flex, Switch, useToast, Collapse, PinInput, PinInputField } from "@chakra-ui/react";
import { QRCodeSVG } from "qrcode.react";

import { IoCloseSharp, IoCopyOutline } from 'react-icons/io5'
import { copyToUserClipboard, generateRandomString, triggerLaunchdeckToast } from '../../global/helpers/global-helpers';
import { updateDsr, resetUpdateDsrOutcome } from '../../digital-sales-room/actions/dsr-actions';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import WarningTextMessage from '../../global/components/helper-components/components/WarningTextMessage';
import ProAccountNeededIcon from '../../global/components/product-marketing/ProAccountNeededIcon';
import { displayReactIcon } from '../helpers/dsr-display-helpers';
import { displayEmoji } from '../helpers/dsr-helpers';
import StripeCheckoutButton from '../../payments/components/StripeCheckoutButton';
import LaunchdeckShortLogo from '../../global/components/helper-components/components/LaunchdeckShortLogo';
import usePopover from '../../global/hooks/driver-popover';
import useAccessSettingTour from '../../global/hooks/room-access-settings-tour';
import LaunchdeckTourButton from '../../global/components/helper-components/components/LaunchdeckTourButton';
import LaunchdeckSwitch from '../../global/components/helper-components/components/LaunchdeckSwitch';
import PlainFormTextInput from '../../forms/TextInputField/components/PlainFormTextInput';
import { BsCheckCircle, BsCircle } from 'react-icons/bs';
import { MdOutlinePublic, MdOutlineSupervisedUserCircle } from 'react-icons/md';

function DsrAccessSettingsForm({
  dsrId,
  thisUserRole,
  // Redux
  dsrStatusRedux,
  dsrPropertiesRedux,
  updateDsrOutcome,
  isMobileView,
  paidFeatureAccess,
  // Actions
  updateDsr,
  resetUpdateDsrOutcome
}) {

  const toggleSaveCodeRef = useRef(false)
  const toast = useToast();
  const history = useHistory();
  const { startHighlight } = usePopover()

  const minCharacters = 6;

  const { displayUrl } = config;
  const publishedDsrLinkDisplay = (displayUrl && dsrId) ? `${displayUrl}/dsr/access/${dsrId}` : null


  // Inputs
  const [accessCodeInput, setAccessCodeInput] = useState("")
  const [selectedOption, setSelectedOption] = useState("")
  const [latestDsrProperties, setLatestDsrProperties] = useState(dsrPropertiesRedux ? dsrPropertiesRedux : {})

  // UX management
  const [showAccessCodeInput, setShowAccessCodeInput] = useState(false)
  const [showValidationError, setShowValidationError] = useState(false)
  const [unlockChangeCodeButton, setUnlockChangeCodeButton] = useState(false)
  const [showAccessCodeSetBanner, setShowAccessCodeSetBanner] = useState(false)
  const [showGetLaunchdeckSeatPrompt, setShowGetLaunchdeckSeatPrompt] = useState(false)
  const [isDsrAdmin, setIsDsrAdmin] = useState(null)
  const [isGuestMember, setIsGuestMember] = useState(false)
  const [triggerToggleSave, setTriggerToggleSave] = useState(false)
  const [joinRoomReminder, setJoinRoomReminder] = useState("")
  const [showDummyCodeInput, setShowDummyCodeInput] = useState(false)
  const [clickCount, setClickCount] = useState(0)
  const [clickCountInviteMode, setClickCountInviteMode] = useState(0)

  const { startRoomAccessTour } = useAccessSettingTour({
    setShowDummyCodeInput
  })

  useEffect(() => {
    switch (thisUserRole) {
      case ("seller-lead"): {
        setIsDsrAdmin(true)
        setIsGuestMember(false)
        break;
      }
      case ("seller-member"): {
        setIsGuestMember(false)
        break;
      }
      case ("buyer-member"): {
        setIsGuestMember(true)
        break;
      }
      default: {
        break;
      }
    }
  }, [thisUserRole])

  useEffect(() => {
    if (dsrPropertiesRedux) {
      const { roomSettings } = dsrPropertiesRedux || {};
      const { inviteMode, accessCodeProtected, accessCodeChallenge, showJoinRoomReminder } = roomSettings || {};

      setLatestDsrProperties(dsrPropertiesRedux)
      setSelectedOption(inviteMode ? inviteMode : paidFeatureAccess ? "anyone" : "invited-members-only")
      setShowAccessCodeInput(accessCodeProtected ? accessCodeProtected : false)
      setJoinRoomReminder((typeof showJoinRoomReminder === "boolean") ? showJoinRoomReminder : false)

      if (accessCodeProtected === true) {
        setAccessCodeInput(accessCodeChallenge ? accessCodeChallenge : "")
      }
    }
  }, [dsrPropertiesRedux]);

  useEffect(() => {
    if (updateDsrOutcome) {
      const { sourceEvent } = updateDsrOutcome || {};

      if (sourceEvent === "save-room-access-code") {
        setShowAccessCodeSetBanner(true)
        setUnlockChangeCodeButton(false)
      }

      if (sourceEvent === "save-room-properties") {
        toast(triggerLaunchdeckToast({ label: "New settings applied", isMobileView }))
      }

      resetUpdateDsrOutcome()
    }
  }, [updateDsrOutcome, resetUpdateDsrOutcome])

  useEffect(() => {

    if (accessCodeInput && triggerToggleSave && !toggleSaveCodeRef.current) {
      handleSetAccessCode('set-code')
      setTriggerToggleSave(false)
      toggleSaveCodeRef.current = true
    }

  }, [accessCodeInput, triggerToggleSave])


  const handleChangeInviteMode = (selectedMode) => {
    let { roomSettings } = latestDsrProperties || {}
    let updatedDsrProperties = '';
    // invited-members-only
    setSelectedOption(selectedMode)
    setClickCountInviteMode(prevCount => prevCount + 1)

    const isInvitedMembersOnly = (selectedMode === "invited-members-only") ? true : false

    if (latestDsrProperties) {
      updatedDsrProperties = {
        ...latestDsrProperties,
        roomSettings: {
          ...roomSettings,
          inviteMode: selectedMode,
          ...(isInvitedMembersOnly && { accessCodeProtected: false })
        }
      }
    } else {
      updatedDsrProperties = {
        roomSettings: {
          inviteMode: selectedMode,
          ...(isInvitedMembersOnly && { accessCodeProtected: false })
        }
      }
    }

    if (updatedDsrProperties) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: updatedDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }


  }
  const onChangeHandler = event => {
    switch (event.target.name) {
      case ('access-code-input'): {
        setAccessCodeInput(event.target.value.toUpperCase())
        setShowAccessCodeSetBanner(false)
        break;
      }
      default: {
        break;
      }
    }
  };

  const handleSetAccessCode = (mode) => {
    //Possible modes: 'set-code' & 'remove-code'
    let { roomSettings } = latestDsrProperties || {}
    let updatedDsrProperties = '';
    let sourceEvent = "";

    if (accessCodeInput && accessCodeInput?.length >= minCharacters) {
      setShowValidationError(false)
      sourceEvent = (mode === "set-code") ? "save-room-access-code" : (mode === "remove-code") ? "remove-room-access-code" : "";

      if (latestDsrProperties) {
        updatedDsrProperties = {
          ...latestDsrProperties,
          roomSettings: {
            ...roomSettings,
            accessCodeProtected: (mode === 'set-code') ? true : false,
            accessCodeChallenge: (mode === 'set-code') && accessCodeInput
          }
        }

      } else {
        updatedDsrProperties = {
          roomSettings: {
            accessCodeProtected: (mode === 'set-code') ? true : false,
            accessCodeChallenge: (mode === 'set-code') && accessCodeInput
          }
        }

      }

      if (updatedDsrProperties) {
        updateDsr({
          dsrId,
          dsrProperties: updatedDsrProperties,
          sourceEvent
        })
      }
    } else {
      setShowValidationError(true)
    }
  }

  const handleAccessCodeProtectToggle = () => {
    if (showAccessCodeInput === true) {
      // Currently true, before getting switched off
      handleSetAccessCode('remove-code')
      setShowAccessCodeSetBanner(false)
      setTriggerToggleSave(false)
      toggleSaveCodeRef.current = false
    } else {
      if (!accessCodeInput) {
        setAccessCodeInput(generateRandomString(minCharacters).toUpperCase())
        setTriggerToggleSave(true)
      }

      if (accessCodeInput) {
        setTriggerToggleSave(true)
        handleSetAccessCode('set-code')
      }
    }

    setShowAccessCodeInput(!showAccessCodeInput)
  }


  const handleCopyLink = () => {
    copyToUserClipboard(publishedDsrLinkDisplay)

    toast(
      triggerLaunchdeckToast({
        useCase: "show-success-state",
        label: "Share link copied",
        isMobileView
      })
    )
  }

  const renderCopyLinkText = () => {
    let copyLinkText = "";

    if (dsrStatusRedux === "active") {
      copyLinkText = publishedDsrLinkDisplay;

    } else {
      copyLinkText = "An invite link will be generated once this Room is published"
    }

    return copyLinkText;
  }

  const handleSetShowJoinRoomReminder = () => {
    let { roomSettings } = latestDsrProperties || {}
    let updatedDsrProperties = '';

    setJoinRoomReminder(!joinRoomReminder)

    if (latestDsrProperties) {
      updatedDsrProperties = {
        ...latestDsrProperties,
        roomSettings: {
          ...roomSettings,
          showJoinRoomReminder: !joinRoomReminder
        }
      }
    } else {
      updatedDsrProperties = {
        roomSettings: {
          inviteMode: "anyone",
          showJoinRoomReminder: !joinRoomReminder
        }
      }
    }

    if (updatedDsrProperties) {
      updateDsr({
        dsrId: dsrId,
        dsrProperties: updatedDsrProperties,
        sourceEvent: "save-room-properties"
      })
    }
  }

  const renderCopyInviteLinkButton = () => {
    if (dsrStatusRedux === "active") {
      return (
        <Flex color='brand.500' cursor='pointer' align='center' onClick={() => handleCopyLink()}>
          <Box as={IoCopyOutline} color='brandDark.500' boxSize='1.2em' />
        </Flex>
      )
    } else return null;
  }

  const renderCopyAccessCodeButton = () => {
    const handleCopyAccessCode = () => {
      copyToUserClipboard(accessCodeInput)

      toast(
        triggerLaunchdeckToast({
          useCase: "show-success-state",
          // bannerText: "",
          label: "Access Code copied",
          isMobileView
        })
      )
    }

    return (
      <Box as={IoCopyOutline} boxSize='1em' position='absolute' right='1em' cursor='pointer' onClick={() => handleCopyAccessCode()} />
    )
  }

  const renderDummyAccessCodeSection = () => {
    const inputSize = '2em';

    return (
      <Box mt='3em' data-driver="room-access-tour-step-3">
        <Flex fontSize='0.875em' justify='space-between' align='center' fontWeight='600' color="brandDark.500">
          <Flex align='center' gap={4}>Access code authorisation</Flex>
          <Switch size="lg" disabled={true} isChecked={true} />
        </Flex>

        <Flex className="fade-in" justify='space-between' align='center' w='100%' mt='1em'>
          <Flex w='100%' position='relative' align='center'>
            <PinInput value={'AK71LR'} autoFocus type='alphanumeric'>
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
              <PinInputField w={inputSize} h={inputSize} mx='0.25em' fontWeight='600' fontSize='1em' />
            </PinInput>

          </Flex>

        </Flex>


      </Box>
    )
  }
  const renderAccessCodeManagement = () => {
    if (isDsrAdmin) {
      if (paidFeatureAccess) {
        return (
          <>
            <Box>
              <Flex justify='space-between' align='center' fontWeight='600' color="brandDark.500">
                <Flex align='center' fontSize='0.875em'>Access code authorisation</Flex>
                <LaunchdeckSwitch
                  fontSize='0.7em'
                  name="accessCodeAuthorisation"
                  isChecked={showAccessCodeInput ? showAccessCodeInput : false}
                  onChange={handleAccessCodeProtectToggle}
                  yesContent='"ON"'
                  noContent='"OFF"'
                  yesBg="brand.500"
                  noBg="gray.300"
                />
              </Flex>

              {showAccessCodeInput &&
                <Flex className="fade-in" justify='space-between' align='center' mt='1em' gap='1em'>
                  <Flex gap='1em'>
                    <Flex position='relative' align='center'>
                      <PlainFormTextInput name={'access-code-input'} htmlFor={'accessCodeInput'}
                        defaultValue={accessCodeInput}
                        upperCaseInputOnly={true}
                        charLimit={minCharacters} w='100%' mb='0em' mt='0em'
                        isDisabled={!unlockChangeCodeButton}
                        focusThisInput={unlockChangeCodeButton}
                        onChange={onChangeHandler} />
                      {renderCopyAccessCodeButton()}
                    </Flex>

                    <Box className='fade-in' key={clickCount}>
                      {
                        (unlockChangeCodeButton === false) ?
                          <LaunchdeckButton bg='brandPink.500' color='white' onClick={() => {
                            setClickCount(prevCount => prevCount + 1)
                            setUnlockChangeCodeButton(true)
                            setShowAccessCodeSetBanner(false)
                          }
                          } >
                            <Flex gap='0.5em' align='center' >
                              {displayReactIcon('unlock', '1em')}
                              <Box>Unlock</Box>
                            </Flex>
                          </LaunchdeckButton>
                          :
                          <LaunchdeckButton bg='brandDark.500' color='white' onClick={() => handleSetAccessCode('set-code')}>

                            <Flex gap='0.5em' align='center'>
                              {displayReactIcon('save-disk', '1em')}
                              Save & Lock
                            </Flex>
                          </LaunchdeckButton>
                      }
                    </Box>
                  </Flex>
                </Flex>

              }

              <WarningTextMessage errorLogic={showValidationError} message={`Your access code needs to contain ${minCharacters} characters`} />

            </Box>
            <Collapse in={showAccessCodeSetBanner} animateOpacity style={{ width: "100%" }} >
              <Flex
                w='100%'
                mt='1em'
                rounded='0.25em'
                bg='gray.50'
                color='brandDark.500'
                justify='space-between'
                align='flex-start'
                p='0.5em'
                border='1px solid'
                borderColor='brand.300'
              >
                <Flex justify='flex-start' align='center' gap={4}>
                  {displayEmoji('sparkle')}

                  <Box fontSize='0.875em' whiteSpace='pre'>{`A one-time access code is now required to join the Room.\nRemember to provide this to any new invited members.`}</Box>
                  {/* <Box fontSize='0.8em' color='gray.500' fontStyle='italic'>This one-time entry code will be required for new members joining</Box> */}

                </Flex>
                <Box cursor='pointer' onClick={() => setShowAccessCodeSetBanner(false)}>
                  <Box as={IoCloseSharp} boxSize='1em' />
                </Box>
              </Flex>
            </Collapse>

          </>
        )
      } else {
        return (
          <Box>
            <Flex data-driver="room-access-tour-step-3" fontSize='0.875em' justify='flex-start' align='center' fontWeight='600' color="brandDark.500">
              <Flex align='center' gap={4} cursor='pointer' onClick={() => setShowGetLaunchdeckSeatPrompt(!showGetLaunchdeckSeatPrompt)}>Access code authorisation {!paidFeatureAccess && <ProAccountNeededIcon />}</Flex>
            </Flex>
          </Box>
        )
      }

    } else {
      if (accessCodeInput) {
        return (
          <Box mt='4em'>
            <Flex w='100%' justify='space-between' align='center'>
              <Box>Access code protected</Box>
            </Flex>
            <Flex className="fade-in" justify='flex-start' align='center' w='100%' mt='1em' position='relative'>
              <PlainFormTextInput isDisabled={true} name={'access-code-input'} htmlFor={'accessCodeInput'} defaultValue={accessCodeInput} upperCaseInputOnly={true} w='100%' mb='0em' mt='0em' />
              {renderCopyAccessCodeButton()}
            </Flex>
          </Box>
        )
      } else return null;
    }
  }

  const renderManageAccessOptions = () => {
    if (isGuestMember) return null

    if (isDsrAdmin) {
      const isAnyoneOption = (selectedOption === "anyone") ? true : false
      return (
        <>
          <Flex gap="0.5em" align='center' mt='2em'>
            <Box fontWeight='600' color="brandDark.500" fontSize='0.875em' lineHeight='1.375em' id='access-setting-explainer'>Who can join</Box>
            <LaunchdeckTourButton handleClick={() => startRoomAccessTour()} />
          </Flex>

          <Box w='100%' fontSize='0.875em'>
            <Flex direction={['column', 'row', 'row', 'row']} gap='1em' justify='space-evenly' align='stretch'>
              <Box flex='1' border='1px solid' borderColor={(selectedOption === 'anyone') ? 'brand.300' : 'gray.300'} bg={(selectedOption === 'anyone') && 'gray.50'} rounded='0.25em' py='0.75em' px='1.25em'
                cursor={(selectedOption === 'anyone') ? 'default' : 'pointer'}
                onClick={() => (selectedOption !== 'anyone') && handleChangeInviteMode('anyone')}
                data-driver="room-access-tour-step-1"
              >
                <Flex w='100%' gap='0.8em' justify='flex-start' align='center'>
                  <Box className='flip-in-hor-bottom'>
                    {
                      (selectedOption === 'anyone') ? <Box as={BsCheckCircle} className='flip-in-hor-bottom' color='brand.500' /> :
                        <Box as={BsCircle} className='flip-in-hor-bottom' color='gray.300' />
                    }
                  </Box>
                  <Flex color={'gray.700'} fontWeight={(selectedOption === 'anyone') && '600'} lineHeight='1.375em' align='center' fontSize='0.9em' gap={4}>{displayReactIcon('public', '1.25em', '', '', 'brandDark.500')} Open to public </Flex>
                </Flex>
                <Box>
                </Box>
              </Box>

              {paidFeatureAccess ?
                <Box flex='1' data-driver="room-access-tour-step-2" border='1px solid' borderColor={(selectedOption === 'invited-members-only') ? 'brand.300' : 'gray.300'} bg={(selectedOption === 'invited-members-only') && 'gray.50'} rounded='0.25em' py='0.75em' px='1.25em' 
                  cursor={(selectedOption !== 'anyone') ? 'default' : 'pointer'}
                  onClick={() => (selectedOption === 'anyone') && handleChangeInviteMode('invited-members-only')}
                >
                  <Flex w='100%' gap='0.8em' justify='flex-start' align='center'>
                    <Box className='flip-in-hor-bottom'>
                      {
                        (selectedOption === 'invited-members-only') ? <Box as={BsCheckCircle} className='flip-in-hor-bottom' color='brand.500' /> :
                          <Box as={BsCircle} className='flip-in-hor-bottom' color='gray.300' />
                      }
                    </Box>
                    <Flex w='100%' color='gray.700' lineHeight='1.375em' align='center' fontSize='0.9em' gap={4}>{displayReactIcon('user', '1.25em', '', '', 'brandDark.500')} Invited members only</Flex>
                  </Flex>

                </Box>
                :
                <Flex
                  flex='1'
                  border='1px solid' borderColor={'gray.300'} rounded='0.25em' py='0.75em' px='1.25em'
                  justify='flex-start' align='center' gap={4}
                  cursor='pointer' fontSize='0.875em'
                  onClick={() => setShowGetLaunchdeckSeatPrompt(!showGetLaunchdeckSeatPrompt)}
                >

                  <Flex justify='flex-start' align='center' >
                    <ProAccountNeededIcon />
                    <Flex ml='1em' color='gray.500'>Invited members only</Flex>
                  </Flex>

                </Flex>
              }
            </Flex>

            {renderSubscriptionNudge()}

            <Box minH='12em' mt='1.8em' rounded='0.5em' bg='gray.50' p='1em' boxShadow={'xs'}>
              {isAnyoneOption ?
                <Box className="fade-in" key={clickCountInviteMode} mb='1em'>
                  <Flex gap='0.5em' px='0.5em' mb='1em' align='center' color='brand.500'>
                    <MdOutlinePublic />
                    <Box fontSize='0.875em' fontWeight='600' color="brandDark.500" letterSpacing='1px'>MEMBERSHIP OPEN TO PUBLIC</Box>
                  </Flex>

                  <Flex direction='column' justify='flex-start' p='0.75em' bg='white' border='1px solid' borderColor='gray.200' rounded='0.5em'>
                    {showDummyCodeInput ? renderDummyAccessCodeSection() : renderAccessCodeManagement()}
                  </Flex>

                  <Flex mt='1em'>
                    <Flex direction='column' justify='flex-start' w='100%' p='0.75em' bg='white' border='1px solid' borderColor='gray.200' rounded='0.5em'>
                      <Flex justify='space-between' align='center' w='100%' >
                        <Flex justify='flex-start' align='center'>
                          <Box id="join-room-reminder-explainer" mr='0.5em' fontSize='0.875em' fontWeight='600' color="brandDark.500" >Show reminder to join room </Box>
                          <LaunchdeckTourButton handleClick={() => startHighlight({
                            elementId: 'join-room-reminder-explainer',
                            elementTitle: 'Joining Reminder',
                            elementDescription: 'Anyone new to the room will be shown a prompt to join the Room. The prompt can be dismissed and they can still view the Room.'
                          })} />
                        </Flex>

                        <LaunchdeckSwitch
                          fontSize='0.7em'
                          name="joinRoomReminder"
                          isChecked={joinRoomReminder}
                          onChange={() => isAnyoneOption && handleSetShowJoinRoomReminder()}
                          yesContent='"YES"'
                          noContent='"NO"'
                          yesBg="brand.500"
                          noBg="gray.300"
                        />

                      </Flex>
                    </Flex>
                  </Flex>
                </Box>
                :
                <Box className="fade-in" key={clickCountInviteMode}>
                  <Flex gap='0.5em' px='0.5em' mb='1em' align='center' color='brandPink.500'>
                    <MdOutlineSupervisedUserCircle />
                    <Box fontSize='0.875em' fontWeight='600' color="brandDark.500" letterSpacing='1px' align='center'>RESTRICTED MEMBERSHIP</Box>
                  </Flex>
                  <Flex direction='column' justify='flex-start' w='100%' p='0.75em' fontSize='0.875em' bg='white' border='1px solid' borderColor='gray.200' rounded='0.5em'>
                    To join this Room, any uninvited person will need to submit a join request that requires Room Administrators approval
                  </Flex>
                </Box>
              }
            </Box>
          </Box>
        </>
      )
    } else {
      return (
        <>
          <Box fontWeight='600' color="brandDark.500" fontSize='0.875em' lineHeight='1.375em'>Who can join</Box>
          <Box mt='1.5em' fontSize='0.875em'>
            {selectedOption === "invited-members-only" ? "Invited members only" : selectedOption === "anyone" ? "Anyone with a link" : "-"}
          </Box>
        </>
      )
    }
  }

  const renderSubscriptionNudge = () => {
    return (
      <Collapse in={showGetLaunchdeckSeatPrompt} animateOpacity style={{ width: "100%" }}>

        <Flex
          w='100%'
          mt='1em'
          rounded='0.25em'
          color='brandDark.500'
          justify='space-between'
          align='flex-start'
          p='0.5em'
          border='1px solid'
          borderColor='brand.300'
        >
          <Flex justify='flex-start' gap={4}>
            <Box px='0.5em'>
              <Flex pt='0.5em' align='flex-start' justify='space-between' w='100%'>
                <LaunchdeckShortLogo boxSize='1.5em' />
                <Box cursor='pointer' onClick={() => setShowGetLaunchdeckSeatPrompt(false)}>
                  <Box as={IoCloseSharp} boxSize='1em' />
                </Box>
              </Flex>
              <Box fontSize='0.875em' fontWeight='600' mt='0.5em'>Ensure only the right people with the right access codes can join your Rooms</Box>
              <Box fontSize='0.8em' color='gray.500'>Generate your own access code with a Launchdeck Seat, at just $1 a day</Box>

              <Box mt='2em'>
                <Flex justify='flex-start' w='100%' mt='1em'>
                  <StripeCheckoutButton sourceRoute={`${history.location.pathname}`} fontSize='0.8em' buttonText="Upgrade" closeModalWhenClicked={true} />
                </Flex>

                <Box fontSize='0.75em' color='gray.500' fontStyle='italic' mt='0.5em'>
                  We're doing this without investors, and especially value your support as our customer. This means delivering features aimed at our users instead of investors.
                  {/* // UUU TODO: Find out more blog / Bluesky*/}
                </Box>
              </Box>
            </Box>
          </Flex>

        </Flex>
      </Collapse>
    )
  }

  const renderShareRoomSection = () => {
    return (
      <>
        <Box fontWeight='600' color="brandDark.500" fontSize='0.875em' lineHeight='1.375em'>Share Room</Box>
        {dsrStatusRedux === "active" &&
          <Box display='flex' width='100%' justifyContent='center' mt='2em'>
            <QRCodeSVG value={publishedDsrLinkDisplay ? publishedDsrLinkDisplay : ''} />
          </Box>
        }
        <Flex className='invite-link-container'>
          <Box className="truncate-long-text">{renderCopyLinkText()}</Box>
          {renderCopyInviteLinkButton()}
        </Flex>
      </>
    )
  }

  return (
    <Flex direction='column' justify='space-around' alignItems='center' pb='2em'>
      <Flex w='100%' direction='column' gap='1em'>
        {renderShareRoomSection()}
        {renderManageAccessOptions()}
      </Flex>
    </Flex>
  )
}


function mapStateToProps(state) {
  return {
    dsrStatusRedux: state.dsrStatus.status,
    dsrPropertiesRedux: state.draftDsrProperties.properties,
    updateDsrOutcome: state.updateDsrOutcome.results.data,
    isMobileView: state.mobileViewMode.isMobileView,
    paidFeatureAccess: state.userPrivileges.results.paidFeatureAccess
  };
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateDsr,
      resetUpdateDsrOutcome
    },
    dispatch,
  )

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DsrAccessSettingsForm));
